function initStoreLocator() {
  if (typeof jQuery === 'undefined') {
    setTimeout(initStoreLocator, 50);
    return;
  }

  $('.store-locator__filter-header').off().on('click', function(e) {
    e.preventDefault();
    var $this = $(this);
	console.log($this.next().hasClass('show'));
    if ($this.next().hasClass('show')) {
      $this.next().removeClass('show');
      $this.removeClass('active');
      $this.next().fadeOut(50);
    } else {
      $this.closest('.filters').find('.store-locator__filter-dropdown').removeClass('show');
      $this.closest('.filters').find('.store-locator__filter-header').removeClass('active');
      $this.closest('.filters').find('.store-locator__filter-dropdown').fadeOut(50);
      $this.next().toggleClass('show');
      $this.toggleClass('active');
      $this.next().fadeToggle(50);
    }
  });

  jQuery('#in-location-section .store-locator__filter-dropdown-item').off().on('click', function() {
    var val = $(this).data('value');
    var textVal = $(this).text();
    var cfilter = $('.custom-filter').find('.store-locator__filter-dropdown-item.selected').attr('data-value');
    jQuery(this).parent().removeClass('show');
    if(val == 'All'){
      jQuery('.store-locator__filter-dropdown-item').removeClass('selected');
      jQuery(this).addClass('selected');
      jQuery(this).closest('.Location_Wrapper').find('.location-cont').show();
      jQuery(this).parent().siblings('.store-locator__filter-header').find('.label').text(textVal);
      jQuery(this).parent().siblings('.store-locator__filter-header').removeClass('active');
      jQuery(this).parent().fadeOut(200);
    }
    else{
      
      jQuery(this).parent().find('.store-locator__filter-dropdown-item').removeClass('selected');
      jQuery(this).addClass('selected');
	  
      jQuery(this).closest('.Location_Wrapper').find('.location-cont').hide();
      if(cfilter == 'All'){
        jQuery(this).closest('.Location_Wrapper').find('.location-cont[data-province="'+val+'"]').show();
      }
      else{
        jQuery(this).closest('.Location_Wrapper').find('.location-cont[data-filter="'+cfilter+'"][data-province="'+val+'"]').show();
      }

      jQuery(this).closest('.Location_Wrapper').find('.location-cont[data-province="'+val+'"]').show();

      jQuery(this).parent().siblings('.store-locator__filter-header').find('.label').text(textVal);

      jQuery(this).parent().siblings('.store-locator__filter-header').removeClass('active');
      jQuery(this).parent().fadeOut(200);
    }
  });
  
  jQuery('#in-location-section .filter-items').off().on('click', function() {
    var val = $(this).data('value');
    var textVal = $(this).text();
    var province = $('.state-filter').find('.store-locator__filter-dropdown-item.selected').attr('data-value');
    jQuery(this).parent().removeClass('show');
    if(val == 'All'){
      jQuery('.filter-items').removeClass('selected');
      jQuery(this).addClass('selected');
      if(province == 'All'){
        jQuery(this).closest('.Location_Wrapper').find('.location-cont').show();
      }
      else{
        jQuery(this).closest('.Location_Wrapper').find('.location-cont[data-province="'+province+'"]').show();
      }
      jQuery(this).parent().siblings('.store-locator__filter-header').find('.label').text(textVal);
      jQuery(this).parent().siblings('.store-locator__filter-header').removeClass('active');
      jQuery(this).parent().fadeOut(200);
    }
    else{
      
      jQuery(this).parent().find('.filter-items').removeClass('selected');
      jQuery(this).addClass('selected');

      jQuery(this).closest('.Location_Wrapper').find('.location-cont').hide();
      if(province == 'All'){
        jQuery(this).closest('.Location_Wrapper').find('.location-cont[data-filter="'+val+'"]').show();
      }
      else{
        jQuery(this).closest('.Location_Wrapper').find('.location-cont[data-filter="'+val+'"][data-province="'+province+'"]').show();
      }

      jQuery(this).parent().siblings('.store-locator__filter-header').find('.label').text(textVal);

      jQuery(this).parent().siblings('.store-locator__filter-header').removeClass('active');
      jQuery(this).parent().fadeOut(200);
    }
  });
  
  jQuery('#online_online-section .filter-items').off().on('click', function() {
    var val = $(this).data('value');
    var textVal = $(this).text();
    if(val == 'All'){
      jQuery('.filter-items').removeClass('selected');
      jQuery(this).addClass('selected');
      jQuery(this).closest('.Location_Wrapper').find('.location-cont').show();
      jQuery(this).parent().siblings('.store-locator__filter-header').find('.label').text(textVal);
      jQuery(this).parent().siblings('.store-locator__filter-header').removeClass('active');
      jQuery(this).parent().removeClass('show');
      jQuery(this).parent().fadeOut(200);
    }
    else{
      
      jQuery(this).parent().find('.filter-items').removeClass('selected');
      jQuery(this).addClass('selected');

      jQuery(this).closest('.Location_Wrapper').find('.location-cont').hide();
      jQuery(this).closest('.Location_Wrapper').find('.location-cont[data-filter="'+val+'"]').show();
      jQuery(this).parent().siblings('.store-locator__filter-header').find('.label').text(textVal);

      jQuery(this).parent().siblings('.store-locator__filter-header').removeClass('active');
      jQuery(this).parent().removeClass('show');
      jQuery(this).parent().fadeOut(200);
    }
  });

  jQuery('.Header_Top ul li a').on('click',function (e) {
    e.preventDefault();
    var target = this.hash;
    var $target = $(target);
    jQuery('html, body').stop().animate({
      'scrollTop': $target.offset().top - 120
    }, 900, 'swing', function () {
    });
  });

}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStoreLocator);
} else {
  initStoreLocator();
}
